import { connectionsConstants } from "../../actions/connections/index";

const defaultState = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: ""
    }
  }
};

function remapCompany(value) {
  if (!value) {
    return {};
  }
  return {
    fiscalCode: value ? value.codiceFiscale : null,
    vatNumber: value ? value.partitaIva : null,
    name: value ? value.ragioneSociale : null,
    type: value ? value.tipologia : null,
    address: {
      street: value && value.sedeLegale ? value.sedeLegale.indirizzo : value.indirizzo || "",
      zipCode: value && value.sedeLegale ? value.sedeLegale.cap : value.cap || "",
      province: value && value.sedeLegale ? value.sedeLegale.provincia : value.provincia || "",
      city: value && value.sedeLegale ? value.sedeLegale.citta : value.citta || "",
      country: value && value.sedeLegale ? value.sedeLegale.nazione : value.nazione || ""
    },
    modifiedAt: value.dataUltimaModifica || "",
    status: value.stato || "",
    taxRegime: value.regimeFiscale || "",
    enableConsole: value.enableConsole || ""
  };
}

export default function connections(state, { type, payload, error }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case connectionsConstants.FETCH_BUSINESS_CONSULTANTS_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case connectionsConstants.FETCH_BUSINESS_CONSULTANTS_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      businessConsultants: payload.list.map((x) => remapCompany(x))
    };
  case connectionsConstants.FETCH_BUSINESS_CONSULTANTS_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false,
        errorInfo: { code: error.code, message: error.message }
      }
    };
  default:
    return defaultS;
  }
}
